<template>
    <div class="tooltip" ref="speech">
        <span class="tooltiptext">{{ text }}</span>
    </div>
</template>

<script>
export default {
  name: 'SpeechBubble',
  mounted: function () {
    const width = this.$refs.speech.offsetWidth
    const height = this.$refs.speech.offsetHeight
    this.$refs.speech.style.position = 'fixed'
    this.$refs.speech.style.z = '10'
    this.$refs.speech.style.left = this.position[0] - (width / 2) + 'px'
    this.$refs.speech.style.top = this.position[1] - 1.2 * (height) + 'px'
  },
  props: {
    position: {
      type: Array,
      required: true
    },
    text: {
      type: String,
      required: true
    }
  }
}
</script>

<style>
.tooltip {
    position: relative;
    display: inline-block;
    border-bottom: 1px dotted black;
}

.tooltip .tooltiptext {
    visibility: hidden;
    width: 120px;
    background-color: black;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px 0;
    position: absolute;
    z-index: 1;
    top: 150%;
    left: 50%;
    margin-left: -60px;
}

.tooltip .tooltiptext::after {
    content: "";
    position: absolute;
    bottom: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent black transparent;
}

.tooltip:hover .tooltiptext {
    visibility: visible;
}
</style>
